<template>
  <div class="loader">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ $t('loading') }}</span>
    </div>
  </div>
</template>
